import { render, staticRenderFns } from "./MicrobiologyMainView.vue?vue&type=template&id=6cb12fd5&scoped=true"
import script from "./MicrobiologyMainView.vue?vue&type=script&lang=js"
export * from "./MicrobiologyMainView.vue?vue&type=script&lang=js"
import style0 from "./MicrobiologyMainView.vue?vue&type=style&index=0&id=6cb12fd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb12fd5",
  null
  
)

export default component.exports